import * as React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Redirect, NavLink } from "react-router-dom";

class Home extends React.Component<any, any> {
    render() {
        let { auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div>
                <div className="crm-menu">
                    <div className="wrapper">
                        <span className="crm-menu__title">Главная</span>
                        <div className="crm-menu__items">
                            <NavLink className="crm-menu__item" to="/admin/holders">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="45"
                                    height="31.5"
                                    viewBox="0 0 45 31.5"
                                >
                                    <path
                                        id="Icon_awesome-users"
                                        data-name="Icon awesome-users"
                                        d="M6.75,15.75a4.5,4.5,0,1,0-4.5-4.5A4.5,4.5,0,0,0,6.75,15.75Zm31.5,0a4.5,4.5,0,1,0-4.5-4.5A4.5,4.5,0,0,0,38.25,15.75ZM40.5,18H36a4.487,4.487,0,0,0-3.171,1.308A10.285,10.285,0,0,1,38.109,27H42.75A2.248,2.248,0,0,0,45,24.75V22.5A4.5,4.5,0,0,0,40.5,18Zm-18,0a7.875,7.875,0,1,0-7.875-7.875A7.871,7.871,0,0,0,22.5,18Zm5.4,2.25h-.584a10.873,10.873,0,0,1-9.633,0H17.1A8.1,8.1,0,0,0,9,28.35v2.025a3.376,3.376,0,0,0,3.375,3.375h20.25A3.376,3.376,0,0,0,36,30.375V28.35A8.1,8.1,0,0,0,27.9,20.25Zm-15.729-.942A4.487,4.487,0,0,0,9,18H4.5A4.5,4.5,0,0,0,0,22.5v2.25A2.248,2.248,0,0,0,2.25,27H6.884A10.311,10.311,0,0,1,12.171,19.308Z"
                                        transform="translate(0 -2.25)"
                                        fill="#8D8E96"
                                    />
                                </svg>
                                <span className="crm-menu__subtitle">ПАРТНЕРЫ</span>
                                <span className="badge fs-14">{this.props.counts.artists}</span>
                            </NavLink>
                            {/* <NavLink className="crm-menu__item" to="/admin/producers">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="31.5"
                                    height="36"
                                    viewBox="0 0 31.5 36"
                                >
                                    <path
                                        id="Icon_awesome-user-tie"
                                        data-name="Icon awesome-user-tie"
                                        d="M15.75,18a9,9,0,1,0-9-9A9,9,0,0,0,15.75,18Zm6.736,2.292L19.125,33.75l-2.25-9.562,2.25-3.937h-6.75l2.25,3.938-2.25,9.563L9.014,20.292A9.434,9.434,0,0,0,0,29.7v2.925A3.376,3.376,0,0,0,3.375,36h24.75A3.376,3.376,0,0,0,31.5,32.625V29.7a9.434,9.434,0,0,0-9.014-9.408Z"
                                        fill="#8d8e96"
                                    />
                                </svg>
                                <span className="crm-menu__subtitle">ПРОДЮСЕРЫ</span>
                            </NavLink> */}
                            <NavLink className="crm-menu__item" to="/admin/objects">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="36"
                                    height="36"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        id="Icon_open-musical-note"
                                        data-name="Icon open-musical-note"
                                        d="M36,0C13.5,0,9,4.5,9,4.5V22.905A7.382,7.382,0,0,0,6.75,22.5a6.75,6.75,0,1,0,6.75,6.75V11.385c3.285-1.035,8.955-1.98,18-2.25v9.27A7.382,7.382,0,0,0,29.25,18,6.75,6.75,0,1,0,36,24.75Z"
                                        fill="#8d8e96"
                                    />
                                </svg>
                                <span className="crm-menu__subtitle">ОБЪЕКТЫ</span>
                                <span className="badge fs-14">{this.props.counts.compositions}</span>
                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/groups">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="36"
                                    height="36.001"
                                    viewBox="0 0 36 36.001"
                                >
                                    <path
                                        id="Icon_awesome-layer-group"
                                        data-name="Icon awesome-layer-group"
                                        d="M.873,10.408l16.379,7.43a1.8,1.8,0,0,0,1.5,0l16.379-7.43a1.571,1.571,0,0,0,0-2.815L18.749.162a1.8,1.8,0,0,0-1.5,0L.873,7.592a1.572,1.572,0,0,0,0,2.815Zm34.255,6.207-4.084-1.851L19.678,19.915a4.053,4.053,0,0,1-3.355,0L4.958,14.764.873,16.615a1.569,1.569,0,0,0,0,2.813l16.379,7.424a1.806,1.806,0,0,0,1.5,0l16.379-7.424a1.569,1.569,0,0,0,0-2.812Zm0,8.986-4.069-1.844L19.678,28.915a4.053,4.053,0,0,1-3.355,0L4.942,23.756.873,25.6a1.569,1.569,0,0,0,0,2.813l16.379,7.424a1.806,1.806,0,0,0,1.5,0l16.379-7.424a1.569,1.569,0,0,0,0-2.812Z"
                                        transform="translate(0 0.001)"
                                        fill="#8d8e96"
                                    />
                                </svg>

                                <span className="crm-menu__subtitle">ГРУППЫ</span>
                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/moderators">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="44.995"
                                    height="36"
                                    viewBox="0 0 44.995 36"
                                >
                                    <path
                                        id="Icon_awesome-user-cog"
                                        data-name="Icon awesome-user-cog"
                                        d="M42.926,26.248a8.248,8.248,0,0,0,0-3L44.74,22.2a.509.509,0,0,0,.232-.6,10.552,10.552,0,0,0-2.334-4.036.513.513,0,0,0-.633-.1L40.191,18.52a8.255,8.255,0,0,0-2.595-1.5v-2.1a.512.512,0,0,0-.4-.5,10.609,10.609,0,0,0-4.655,0,.512.512,0,0,0-.4.5v2.1a8.255,8.255,0,0,0-2.595,1.5l-1.814-1.048a.514.514,0,0,0-.633.1,10.552,10.552,0,0,0-2.334,4.036.518.518,0,0,0,.232.6l1.814,1.048a8.248,8.248,0,0,0,0,3L25,27.3a.509.509,0,0,0-.232.6A10.6,10.6,0,0,0,27.1,31.929a.513.513,0,0,0,.633.1l1.814-1.048a8.255,8.255,0,0,0,2.595,1.5v2.1a.512.512,0,0,0,.4.5,10.609,10.609,0,0,0,4.655,0,.512.512,0,0,0,.4-.5v-2.1a8.255,8.255,0,0,0,2.595-1.5L42,32.027a.514.514,0,0,0,.633-.1,10.552,10.552,0,0,0,2.334-4.036.518.518,0,0,0-.232-.6l-1.814-1.048ZM34.875,28.16a3.41,3.41,0,1,1,3.41-3.41A3.413,3.413,0,0,1,34.875,28.16ZM15.75,18a9,9,0,1,0-9-9A9,9,0,0,0,15.75,18ZM29.9,33.926c-.162-.084-.323-.183-.478-.274l-.555.323a2.759,2.759,0,0,1-3.41-.513,12.821,12.821,0,0,1-2.827-4.894,2.75,2.75,0,0,1,1.259-3.213l.555-.323q-.011-.274,0-.548l-.555-.323a2.747,2.747,0,0,1-1.259-3.213c.063-.2.155-.408.225-.612-.267-.021-.527-.084-.8-.084H20.876a12.24,12.24,0,0,1-10.252,0H9.45A9.452,9.452,0,0,0,0,29.7v2.925A3.376,3.376,0,0,0,3.375,36h24.75a3.371,3.371,0,0,0,1.913-.6,2.738,2.738,0,0,1-.141-.83Z"
                                        fill="#8d8e96"
                                    />
                                </svg>

                                <span className="crm-menu__subtitle">СОТРУДНИКИ</span>
                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/requests">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                >
                                    <g
                                        id="Group_245"
                                        data-name="Group 245"
                                        transform="translate(-517 -352)"
                                    >
                                        <g
                                            id="Ellipse_13"
                                            data-name="Ellipse 13"
                                            transform="translate(517 352)"
                                            fill="none"
                                            stroke="#8d8e96"
                                            strokeWidth="3"
                                        >
                                            <circle cx="14" cy="14" r="14" stroke="none" />
                                            <circle cx="14" cy="14" r="12.5" fill="none" />
                                        </g>
                                        <text
                                            id="i"
                                            transform="translate(531 372)"
                                            fill="#8d8e96"
                                            fontSize="16"
                                            fontFamily="SegoeUIBlack, Segoe UI"
                                        >
                                            <tspan x="-2.465" y="0">
                                                i
                                            </tspan>
                                        </text>
                                    </g>
                                </svg>
                                <span className="crm-menu__subtitle">ЗАПРОСЫ</span>
                                <span className="badge fs-14">{this.props.counts.requests}</span>
                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/settings">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="36.61"
                                    height="36.62"
                                    viewBox="0 0 36.61 36.62"
                                >
                                    <path
                                        id="Icon_ionic-ios-settings"
                                        data-name="Icon ionic-ios-settings"
                                        d="M38.088,22.805a4.711,4.711,0,0,1,3.022-4.4,18.674,18.674,0,0,0-2.26-5.444,4.774,4.774,0,0,1-1.916.41,4.7,4.7,0,0,1-4.3-6.617A18.617,18.617,0,0,0,27.2,4.5a4.707,4.707,0,0,1-8.79,0,18.674,18.674,0,0,0-5.444,2.26,4.7,4.7,0,0,1-4.3,6.617,4.619,4.619,0,0,1-1.916-.41A19.086,19.086,0,0,0,4.5,18.42a4.71,4.71,0,0,1,.01,8.79,18.674,18.674,0,0,0,2.26,5.444,4.7,4.7,0,0,1,6.207,6.207,18.783,18.783,0,0,0,5.444,2.26,4.7,4.7,0,0,1,8.771,0,18.674,18.674,0,0,0,5.444-2.26,4.707,4.707,0,0,1,6.207-6.207A18.783,18.783,0,0,0,41.1,27.21,4.733,4.733,0,0,1,38.088,22.805Zm-15.2,7.618A7.627,7.627,0,1,1,30.518,22.8,7.625,7.625,0,0,1,22.891,30.423Z"
                                        transform="translate(-4.5 -4.5)"
                                        fill="#8d8e96"
                                    />
                                </svg>

                                <span className="crm-menu__subtitle">НАСТРОЙКИ</span>
                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/no-sorted">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40.5"
                                    height="36"
                                    viewBox="0 0 40.5 36"
                                >
                                    <path
                                        id="Icon_awesome-file-signature"
                                        data-name="Icon awesome-file-signature"
                                        d="M15.34,29.822a.779.779,0,0,0-.715-.458.767.767,0,0,0-.7.435l-.539,1.079a1.125,1.125,0,0,1-2.073-.147l-1.183-3.549-.746,2.242A3.036,3.036,0,0,1,6.5,31.5H5.625a1.125,1.125,0,0,1,0-2.25H6.5a.788.788,0,0,0,.748-.539L8.523,24.87a1.688,1.688,0,0,1,3.2,0L12.7,27.8a3.155,3.155,0,0,1,4.641,1,.8.8,0,0,0,.658.44V23.459l9-8.936V11.25H17.438A1.692,1.692,0,0,1,15.75,9.563V0H1.688A1.683,1.683,0,0,0,0,1.688V34.313A1.683,1.683,0,0,0,1.688,36H25.313A1.683,1.683,0,0,0,27,34.313V31.5l-9-.008A3.019,3.019,0,0,1,15.34,29.822ZM27,8.571a1.682,1.682,0,0,0-.492-1.188L19.624.492A1.686,1.686,0,0,0,18.429,0H18V9h9ZM20.25,24.4V29.25H25.1L36.469,17.8,31.7,13.032,20.25,24.4Zm19.725-12.63L37.735,9.525a1.791,1.791,0,0,0-2.532,0l-1.916,1.916,4.773,4.773L39.975,14.3A1.79,1.79,0,0,0,39.975,11.765Z"
                                        fill="#8d8e96"
                                    />
                                </svg>

                                <span className="crm-menu__subtitle">НЕСОРТИРОВАННЫЕ</span>
                                <span className="badge fs-14">{this.props.counts.nosorted}</span>

                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/black-list">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="29.257"
                                    height="29.257"
                                    viewBox="0 0 29.257 29.257"
                                >
                                    <path
                                        id="Icon_ionic-ios-list-box"
                                        data-name="Icon ionic-ios-list-box"
                                        d="M3.375,5.815V30.192a2.441,2.441,0,0,0,2.44,2.44H30.192a2.441,2.441,0,0,0,2.44-2.44V5.815a2.441,2.441,0,0,0-2.44-2.44H5.815A2.437,2.437,0,0,0,3.375,5.815ZM9.654,26.7A1.4,1.4,0,1,1,10.863,25.5,1.4,1.4,0,0,1,9.654,26.7Zm0-7.312a1.4,1.4,0,1,1,1.209-1.209A1.4,1.4,0,0,1,9.654,19.392Zm0-7.312a1.4,1.4,0,1,1,1.209-1.209A1.4,1.4,0,0,1,9.654,12.08ZM27.049,26.3H14.393a.987.987,0,0,1-.984-.984h0a.987.987,0,0,1,.984-.984H27.049a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,27.049,26.3Zm0-7.312H14.393A.987.987,0,0,1,13.409,18h0a.987.987,0,0,1,.984-.984H27.049a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,27.049,18.984Zm0-7.312H14.393a.987.987,0,0,1-.984-.984h0a.987.987,0,0,1,.984-.984H27.049a.987.987,0,0,1,.984.984h0A.987.987,0,0,1,27.049,11.672Z"
                                        transform="translate(-3.375 -3.375)"
                                        fill="#8d8e96"
                                    />
                                </svg>

                                <span className="crm-menu__subtitle">ЧЕРНЫЙ СПИСОК</span>
                            </NavLink>
                            <NavLink className="crm-menu__item" to="/admin/questions">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                >
                                    <path
                                        id="Icon_material-question-answer"
                                        data-name="Icon material-question-answer"
                                        d="M31.5,9h-3V22.5H9v3A1.5,1.5,0,0,0,10.5,27H27l6,6V10.5A1.5,1.5,0,0,0,31.5,9Zm-6,9V4.5A1.5,1.5,0,0,0,24,3H4.5A1.5,1.5,0,0,0,3,4.5v21l6-6H24A1.5,1.5,0,0,0,25.5,18Z"
                                        transform="translate(-3 -3)"
                                        fill="#8d8e96"
                                    />
                                </svg>

                                <span className="crm-menu__subtitle">ВОПРОСЫ</span>
                                <span className="badge fs-14">{this.props.counts.tickets}</span>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
        counts: state.counts
    };
})(Home);